// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Country_wrapper__3YM9B","image":"Country_image__1rgL0","content":"Country_content__3stph"};